module["exports"] = ["gmail.com", "yahoo.com", "hotmail.com", "email.it", "libero.it", "yahoo.it"];